var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShipmentQuestionShippingDelivery = function SvgShipmentQuestionShippingDelivery(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 46.5a12 12 0 1 0 0-24 12 12 0 0 0 0 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75 32.25A3.75 3.75 0 1 1 34.5 36m0 6a.75.75 0 0 1 0-1.5m0 1.5a.75.75 0 0 0 0-1.5m-18-3h-12a3 3 0 0 1-3-3v-21a3 3 0 0 1 3-3h30a3 3 0 0 1 3 3v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.532 11.294 30.89 2.836A3 3 0 0 0 28.4 1.5H10.6a3 3 0 0 0-2.496 1.336l-5.636 8.458M19.5 1.5v9"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShipmentQuestionShippingDelivery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "shipment-question-shipping-delivery.bd2a0d0a0934393624283f74ef83a13f.svg";